import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const LanguageLinks = ({ links }) => (
    <Helmet>
        {links.map(({ uri, locale }) => {
            if (!uri) {
                return null;
            }

            if (uri.toLowerCase().indexOf("//") === 0) {
                uri = `https:${uri}`;
            }

            const lang = locale.substr(0, 2);

            return <link key={locale} href={uri} rel="alternate" hrefLang={lang} />;
        })}
    </Helmet>
);

LanguageLinks.propTypes = {
    links: PropTypes.array.isRequired,
};

export default LanguageLinks;
